export const LoadingBar = (props) => {
  return (
    <div className="_padding--1rem_0rem_1rem_1rem _display--flex">
      <div className="_display--inline-block">
        <i className="fa-regular fa-file _font-size--2rem _color--var_gray-40_"></i>
      </div>
      <div className="_display--inline-block _margin-left--1rem _width---webkit-fill-available">
        <p>{props.text}</p>

        <div className="progress-bar">
          <div
            className="_height--4px _background-color--var_green-10_ _margin-top--5px"
            style={{
              width: (props.statusNumber / props.totalNumber) * 100 + "%",
            }}
          ></div>
        </div>
        <p className="_font-size--10pt _text-align--right">
          {props.statusNumber + " / " + props.totalNumber}
        </p>
      </div>
    </div>
  );
};
